import { useState } from 'preact/hooks';

const CHOOSE_DROP_OFF_LOCATION_STEP = 0;
const CONFIRM_DROP_OFF_LOCATION_STEP = 1;

interface ReturnTypeUseSteps {
  currentStep: number;
  goToNextStep: () => void;
  goToPreviousStep: () => void;
}

const useSteps = (): ReturnTypeUseSteps => {
  const [currentStep, setCurrentStep] = useState<number>(
    CHOOSE_DROP_OFF_LOCATION_STEP,
  );

  const goToNextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const goToPreviousStep = () => {
    setCurrentStep(currentStep - 1);
  };

  return {
    currentStep,
    goToNextStep,
    goToPreviousStep,
  };
};

export {
  useSteps,
  CHOOSE_DROP_OFF_LOCATION_STEP,
  CONFIRM_DROP_OFF_LOCATION_STEP,
};
